<script>
    import { get_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/get_stock.js?1733898724646';
    import Stock from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Stock.svelte?1733898724646';

    export let product;
    $: stock = get_stock(product);
    $: in_stock = stock?.is_in_stock || false;
    $: qty = stock?.qty || 0;
</script>

<Stock {in_stock} {qty} />
